import DosingRow from 'components/DosingRow/DosingRow';
import DosingTitle from 'forms/DosingInfo/DosingTitle/DosingTitle';

const TitratedDosing = () => {
  return (
    <div
      className="tab-pane"
      id="pills-titrated-2"
      role="tabpanel"
      aria-labelledby="pills-titrated-tab-2"
      tabIndex={1}
    >
      <div className="dosing-form-container">
        <DosingTitle
          subtitle="1 time a night dosing (IH patients)"
          title="Titrated XYWAV Dosing: Titrate to Effect"
        />

        <DosingRow
          title="Starting Dose"
          fields={{
            doses: ['rems:titratedDosing:effect:ih:startingDose:dose'],
            timeOfDrugTaking: 'rems:titratedDosing:effect:ih:startingDose:dose:numOfDays',
          }}
          timeOfDrugTakingInformation={true}
        />
        <DosingRow
          title="1st Titration"
          fields={{
            doses: ['rems:titratedDosing:effect:ih:1stTitration:dose'],
            timeOfDrugTaking: 'rems:titratedDosing:effect:ih:1stTitration:dose:numOfDays',
          }}
        />
        <DosingRow
          title="2nd Titration"
          fields={{
            doses: ['rems:titratedDosing:effect:ih:2ndTitration:dose'],
            timeOfDrugTaking: 'rems:titratedDosing:effect:ih:2ndTitration:dose:numOfDays',
          }}
        />
        <DosingRow
          title="3rd Titration"
          fields={{
            doses: ['rems:titratedDosing:effect:ih:3rdTitration:dose'],
            timeOfDrugTaking: 'rems:titratedDosing:effect:ih:3rdTitration:dose:numOfDays',
          }}
        />
      </div>
      <div className="col-12 small pt-3 fw-bold">
        <div>
          Doses may be divided equally or unequally and the first dose taken at bedtime and the
          second dose taken 2.5 to 4 hours later.
        </div>
        <div>
          *For pediatric patients who sleep more than 8 hours per night, the first dose of XYWAV may
          be given at bedtime or after an initial period of sleep.
        </div>
        <div>
          **If XYWAV is used in patients 7 years of age and older who weigh less than 20 kg, a lower
          starting dosage, lower maximum weekly dosage increases, and lower total maximum nightly
          dosage should be considered.
        </div>
      </div>
    </div>
  );
};

export default TitratedDosing;
